/**
 * This file is manually copied over from the hekate repo
 */
/*
Maps the Eloqua id of forms to more human readable names

Content - Default Content Download Lead 23
WWW - Contact Us Form 32
WWW - Demo Request 36
Webinar - Webinar Registration Form 46
Edu - Enterprise Request Form 54
WWW - Entrepreneur program form 60
WWW - Contact Sales 70
Edu - Academic Webinar Registration Form 99
Hekate - Gated Content Progressive Profile 125
[Product] Product Signup Landing Page (Hidden) 127
CAD Account Creation Request 134
WWW - Get Started Contact 136
[TRIAL] - Hidden Form 137
Edu - Product Signup (Hidden) 139
[Trial] Unified Pro Trial 143
[EDU] Account Signup 145
Refer a Friend - Referrer 149
Refer a Friend - Referred [Hidden] 150
Referral - Internal 160
Email Subscription Preferences 151
WWW - Upgrade Render Studio 163

Event - Event Registration Form 101
[EDU] - Edu Signup Request 168

WWW - Contact Sales Form 152
WWW - Contact Us Form ABM 154
[Free] Free Plan Signup 158
*/
/**
 ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
 ** Update this by copying the file from Hekate
 ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
 */
class FormIdUtil {
    /** Returns true if this a Product signup for (i.e. makes a request to cad invite) */
    static isCadInviteForm({ formId }) {
        return (formId === FormIdUtil.names.gettingStartedTrial ||
            formId === FormIdUtil.names.unifiedTrialRequest ||
            formId === FormIdUtil.names.freePlanSignup ||
            formId === FormIdUtil.names.unifiedSignup);
    }
}
FormIdUtil.names = {
    defaultContentDownloadLead: '23',
    contactUs: '32',
    demoRequest: '36',
    webinarRegistration: '46',
    eduEnterpriseRequest: '54',
    wwwEntrepreneurProgram: '60',
    wwwContactSales: '152',
    eduAcademicWebinarRegistration: '99',
    gatedContentProgressiveProfile: '125', // DEPRECATED
    productSignupLandingPageHidden: '127',
    wwwGetStartedContact: '136',
    trialHiddenForm: '137',
    eduProductSignupHidden: '139', // DEPRECATED
    requestProTrialFromFree: '45',
    upgradeRenderStudio: '163',
    upgradeStandardToPro: '166',
    // Signup Forms
    gettingStartedTrial: '134',
    unifiedTrialRequest: '143',
    freePlanSignup: '158',
    unifiedSignup: '182',
    eduForm: '168',
    eventForm: '101',
    referAFriendReferrer: '149',
    referAFriendReferred: '150',
    internalReferral: '160',
    emailSubscriptionPreferences: '151',
    signupSurvey: '181',
    referToDisco: '195',
    /**
     ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
     ***  Update from Hekate
     ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** **
     */
};
export default FormIdUtil;
